<template>
  <div id="orderinfo" class="orderinfo userbox" v-loading.fullscreen="loading">
    <div class="userTitle">我的订单</div>
    <div class="userOrderTab space_between">
      <ul class="AllTab" v-if="orderCount!=null">
        <li :class="orderTab==''?'on':''" @click="setTab('')">全部 ({{orderCount.All}})</li>
        <li :class="orderTab==1?'on':''" @click="setTab(1)">待支付 ({{orderCount.Unpaid}})</li>
        <li :class="orderTab==2?'on':''" @click="setTab(2)">待发货 ({{orderCount.Shipping}})</li>
        <li :class="orderTab==3?'on':''" @click="setTab(3)">待收货 ({{orderCount.Shipped}})</li>
        <li :class="orderTab==5?'on':''" @click="setTab(5)">已完成 ({{orderCount.ShippComplete}})</li>
      </ul>
      <el-input placeholder="输入内容查询" v-model="orderSearch" class="orderSearch">
        <i slot="suffix" class="searchIcon"></i>
      </el-input>
    </div>
    <div v-if="!isNull">
      <div class="order_list order_list_title">
        <div class="order_list_products">商品</div>
        <div class="order_list_detail">详情</div>
        <div class="order_list_price">单价</div>
        <div class="order_list_total">总价</div>
        <div class="order_list_operate">操作</div>
      </div>
      <div class="order_list_border" v-for="(item,index) in list" :key="index" v-if="list!=null">
        <div class="order_list order_list_id">
          <div class="order_list_products">{{item.CreateDate}}</div>
          <div class="order_list_detail">订单号：{{item.OrderCode}}</div>
          <span class="icon_payOther"  v-if="item.Status==1&&item.PayType==2&&item.PayCheck==1">待审核</span>
          <span class="icon_payOther close"  v-if="item.Status==6">订单已关闭</span>
        </div>
        <div class="order_list" v-for="(res,j) in item.OrderDetails" :key='j' :class="item.OrderPresale==1?'presale':''">
          <div class="order_list_products">
            <router-link class="order_img" :to="{path:'/market/item/'+(res.OldCommodityId?res.OldCommodityId:res.CommodityId)+'?type=1'}">
              <img :src="res.TitImg+'?imageView2/2/w/160'">
              <span class="icon_presale" v-if="item.OrderPresale==1">预售</span>
            </router-link>
          </div>
          <div class="order_list_detail">
            <router-link :to="{path:'/market/item/'+(res.OldCommodityId?res.OldCommodityId:res.CommodityId)+'?type=1'}">
              <p class="line_txt3">{{res.Title}}</p>
            </router-link>
            <span class="order_num">{{res.Num}}</span>
            <span v-if="item.OrderPresale==2" class="order_postage">运费：到付</span>
          </div>
          <!-- 非积分 单价 -->
          <div class="order_list_price" v-if="item.OrderPresale!=2">
            <del v-if="res.LowestPrice!=res.Price">￥{{res.Price.toLocaleString()}}</del>
            <span class="price_red" v-if="res.LowestPrice!=res.Price">{{res.LowestPrice.toLocaleString()}}</span>
            <span v-if="res.LowestPrice==res.Price">{{res.Price.toLocaleString()}}</span>
          </div>
          <!-- 积分 单价-->
          <div class="order_list_price point" v-if="item.OrderPresale==2">
            <span class="pointName">{{res.PointsScore}} 积分</span>
            <span v-if="res.Price>0" class="priceName">{{res.Price.toLocaleString()}}</span>
          </div>
          <!-- 非积分 总价 -->
          <div class="order_list_total" v-if="item.OrderPresale!=2">
            <span>{{item.RealOrderPrice.toLocaleString()}}</span>
          </div>
          <!-- 积分 总价 -->
          <div class="order_list_total point" v-if="item.OrderPresale==2">
            <span class="pointName">{{item.RealPoints}} 积分</span><br/>
            <span v-if='item.RealOrderPrice>0' class="priceName">{{item.RealOrderPrice.toLocaleString()}}</span>
          </div>
          <div class="order_list_operate">
            <el-button type="primary" v-if="item.Status==1&&item.PayType!=2&&item.OrderPresale!=1" @click="payGo(item)">支付</el-button>
            <!-- <el-button type="primary" v-if="item.Status==1&&item.OrderPresale!=1" @click="payGo(item)">支付</el-button> -->
            <!-- <el-button  v-if="item.Status==2">申请退款</el-button> -->
            <el-button type="primary" v-if="item.Status==3" @click="setOrder('确认收货',item)">确认收货</el-button>
            <span v-if="item.PayType==2&&item.PayType!=3" @click="payOrder('payOrder',item)">查看支付凭证</span>
            <span v-if="item.PayType!=2&&item.PaymentPayType==2&&item.PayType!=3" @click="payOrder('payOrder',item)">查看支付凭证</span>
            <!-- <el-button  v-if="item.Status==5" @click="setOrder('删除订单',item)">删除订单</el-button> -->
            <span v-if="item.Status==1&&!item.IsPay" @click="setOrderAddress('setOrderAddress',item)">修改地址</span>
            <!-- <span v-if="item.Status==1&&!item.IsPayDeposit" @click="setOrderAddress('setOrderAddress',item)">修改地址</span> -->
            <router-link :to="{path:'/order/detail/'+item._id}">
              查看详情
            </router-link>
          </div>
          <!-- 预售 -->
          <ul v-if="item.OrderPresale==1&&item.Status!=6" class="presaleList">
            <li>
              <div class="order_list_detail">
                <p class="line_txt3">阶段一：定金</p>
              </div>
              <div class="order_list_price">
                <span>{{priceCount(item.AdvancePrice,res.Num,'div').toLocaleString()}}</span>
              </div>
              <div class="order_list_total">
                <!-- <span>{{priceCount(item.AdvancePrice,res.Num,'multi').toLocaleString()}}</span> -->
                <span>{{item.AdvancePrice.toLocaleString()}}</span>
              </div>
              <div class="order_list_operate">
                <el-button type="primary" @click="payGo(item)" :disabled="item.PayCheck==1&&item.PayType==2" v-if="!item.IsPayDeposit">付款</el-button>
                <span v-else class="yesRpg"></span>
              </div>
            </li>
            <li>
              <div class="order_list_detail">
                <p class="line_txt3">阶段二：尾款</p>
              </div>
              <div class="order_list_price">
                <span>{{priceCount(priceCount(item.RealOrderPrice,item.AdvancePrice,'sub'),res.Num,'div').toLocaleString()}}</span>
              </div>
              <div class="order_list_total">
                <!-- <span>{{priceCount(priceCount(item.RealOrderPrice,item.AdvancePrice,'sub'),res.Num,'multi').toLocaleString()}}</span> -->
                <span>{{priceCount(item.RealOrderPrice,item.AdvancePrice,'sub').toLocaleString()}}</span>
              </div>
              <div class="order_list_operate">
                <el-button type="primary" @click="payGo(item)" v-if="item.IsPayDeposit&&item.Status<2" :disabled="isPay(item)">付款</el-button>
                <span v-if="item.Status>1" class="yesRpg"></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
      <to-address :title='title' :domVisible='dislogType.address' :list='addressItem' :isSet="isSet" @closeDialog="closeDialog" v-if="dislogType.address" />
      <set-address title='选择收货地址' :domVisible='dislogType.setOrderAddress' :infoList="addressInfo" @closeDialog="closeDialog" v-if="dislogType.setOrderAddress" @setAddress="setAddress" />
      <pay-order title='支付凭证' :domVisible='dislogType.payOrder' :infoList="payOrderItem" @closeDialog="closeDialog" v-if="dislogType.payOrder"/>
    </div>
    <nonull type='order' text="未找到订单" v-if="isNull" />
  </div>
</template>
<script>
import { getInfo, numAdd, numSub, numMulti,numDiv} from "@/api/public";
import ToAddress from '@/components/dialog/address'
import SetAddress from '@/components/dialog/setaddress'
import PayOrder from '@/components/dialog/payorder'
import Pagination from '@/components/pagination'
import Nonull from '@/components/nonull'
export default {
  name: 'orderinfo',
  components: { Nonull, Pagination, ToAddress, SetAddress,PayOrder },
  data() {
    return {
      loading: false,
      userInfo: getInfo(),
      orderCount: null,
      addressItem: null,
      payOrderItem:null,
      list: null,
      isSet: false,
      title: "",
      dislogType: this.$enumInfo.dislogType,
      isNull: false,
      orderTab: '', // 全部:'',待支付:1,待发货:2,待收货:3,已完成:6
      list: null,
      orderSearch: '',
      addressInfo: null,
      ps: 24, //pagesize
      pi: 1, //pageindex
      TotalCount: 200
    }
  },
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (that.orderSearch != '') {
        if (e.keyCode === 13) {
          that.getOrdersList()
        }
      }
    })
  },
  created() {
    this.getOrderCount()
     this.$route.query.type?this.setTab(this.$route.query.type):this.setTab('')
    //this.getOrdersList()
  },
  methods: {
    isPay(val){
      let data=val
      let isTrue=true
      if(!data.IsPayment){
      //未开启尾款
        isTrue=true
      }else{
        //已开启尾款
        isTrue=false
        if(data.PaymentPayType==1){
          //线上支付
          isTrue=false
        }else if(data.PaymentPayType==2){
          //线下支付
          isTrue=false
          if(data.PayCheck==1||data.PayType==3){
            isTrue=true
          }
        }
      }
      return isTrue
    },
    //计算价格
    priceCount(num1,num2,type){
      let num=0;
      if(type=='add'){
          num = numAdd(num1, num2)
      }
      if(type=='sub'){
          num = numSub(num1, num2)
      }
      if(type=='multi'){
          num = numMulti(num1, num2)
      }
      if(type=='div'){
          num = numDiv(num1, num2)
      }
      return num
    },
    payGo(obj) {
      let data = { Details: obj.OrderDetails, OrderPrice: obj.RealOrderPrice, AddressId: obj.AddressId }
      window.sessionStorage.setItem('dakacheck', JSON.stringify(data))
      this.$router.push({ path: '/checkout/' + obj._id })
    },
    payOrder(val, obj){
      this.dislogType[val] = true;
      this.payOrderItem = obj;
    },
    getOrderCount() {
      let that = this;
      let data = { MemberId: that.userInfo._id }
      that.$get(that.$interface.GetOrderCountByStatus, data).then(res => {
        if (res.Result != 0) {
          that.orderCount = res.Data
        } else {
          that.$message.error(res.Msg);
        }
      })
    },
    // 全部:'',待支付:1,待发货:2,待收货:3,已完成:6
    //Status 返回值订单状态 待付款=1，待发货=2 待收货=3 交易完成=5，交易关闭=6
    getOrdersList() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, CommodityTitle: that.orderSearch, OrderStatus: that.orderTab, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.GetOrdersPageListByMemberId, data).then(res => {
        if (res.Result != 0) {
          that.isNull = res.Count > 0 ? false : true;
          that.TotalCount = res.Count;
          // res.Data=res.Data.map(item=>{
          //   var i='';
          //    if(item.OrderDetails.length>0){i=item}
          //   return i
          // })
          that.list = res.Data
        } else {
          that.isNull = true;
        }
        that.loading = false;
      })
    },
    setOrderAddress(val, obj) {
      this.dislogType[val] = true;
      this.addressInfo = obj
    },
    setAddress(val, type, obj) {
      this.closeDialog('setOrderAddress', false)
      if (type == 1) {
        this.title = '修改收货地址'
        this.addressItem = JSON.parse(JSON.stringify(obj))
      } else {
        this.title = '添加收货地址'
      }
      this.isSet = type > 0 ? false : true;
      this.dislogType[val] = true;
    },
    closeDialog(val, bol, type) {
      console.log(val, bol, type)
      this.dislogType[val] = bol;
      if (val == 'setOrderAddress' && type == 1) {
        this.getOrdersList()
      }
    },
    setTab(val) {
      this.orderTab = val;
      this.pi = 1;
      this.getOrdersList()
    },
    setOrder(val, obj) {
      let that = this;
      this.$alert(val, '', {
        customClass: 'alert',
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        lockScroll: false,
        callback: action => {
          let data = {
            id: obj._id,
            memberId: that.userInfo._id,
          }
          if (obj.Status == 3) {
            that.$post(that.$interface.MemberCompleteOrder, data).then(res => {
              if (res.Result != 0) {
                that.setTab(5);
                that.getOrderCount()
              }
            })
          }
        }
      });
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getOrdersList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getOrdersList();
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";
</style>



// WEBPACK FOOTER //
// src/pages/user/order.vue